import axios from "axios"
import uri from "./constants"
import * as XLSX from 'xlsx'
import dayjs from "dayjs";
export const functions = {
    //상태 되돌려놓기
    Cancel:async function (str, senddata) {
        

        if (confirm("처리단계가 전단계로 돌아갑니다. 진행하시겠습니까?"))
        {
            senddata.페이지=str
            // if (str == "승인요청취소") { //수주요청취소
                try {
                    await axios.post(uri + "/cancel/status", senddata)
                    alert("처리되었습니다")
                    
                } catch (e) {
                    alert(e)
                }
                
                
            //  }
        }
    },
    $downExcel(pageName){
        const t = document.getElementById('print')
        const workBook = XLSX.utils.book_new() //book_new: workbook을 하나 만듭니다. 엑셀 파일을 하나 만드는 거죠
        //const workSheet = XLSX.utils.json_to_sheet(this.조회데이터) //json_to_sheet: json 데이터를 worksheet 형태로 변환합니다.
        const workSheet = XLSX.utils.table_to_sheet(t) //테이블 데이터를 worksheet 형태로 변환합니다.
        XLSX.utils.book_append_sheet(workBook, workSheet, 'Sheet')
        const t2 = document.getElementById('print2')
        if(t2 != undefined){
            const workSheet2 = XLSX.utils.table_to_sheet(t2)
            XLSX.utils.book_append_sheet(workBook, workSheet2, 'Sheet2')
            
        }
        XLSX.writeFile(workBook,  dayjs().format('YYYY-MM-DD') + '_' + pageName + '.xlsx')
    },
    
}

export default functions
